module.exports = __webpack_public_path__ + "img/pingtai5.4c3c02c9.png";